import Input from './input';

export * from './input';

export default Input;
